import { Layout } from '@components'
import Disclaimer from '@components/Disclaimer'
import { useParams } from '@solidjs/router'
import { type ParentProps, createEffect } from 'solid-js'
import { useService } from 'solid-services'
import { Grid } from 'styled-system/jsx'
import Courses from './Courses'
import Lesson from './Lesson'
import Overview from './Overview'
import { useCourseOverview } from './useCourseOverview'

function Container(props: ParentProps) {
  const params = useParams();
  const { setActiveCourseslug } = useService(useCourseOverview)()

  createEffect(() => {
    if (params.slug) setActiveCourseslug(params.slug)
  })

  return <Grid gap='0' gridTemplateRows='auto 1fr auto'>
    {props.children}
    <Disclaimer />
  </Grid>
}

const routes = [
  {
    path: '/courses',
    component: Container,
    children: [
      {
        path: '/',
        component: Courses,
      },
      {
        path: '/:slug',
        component: Overview,
      },
      {
        path: '/:slug/:lessonSlug',
        component: Lesson,
      },
    ],
  },
]

export default routes
